export * from './src/actions';
export * from './src/reducer';
export * from './src/router-store-module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/router-store/index.js
// module id = 311
// module chunks = 2